export function  getBookLevel(level) {
    return level.join('/');
}
